<fgb-mobile-header [titleKey]="titleKey" [titleDefault]="titleDefault" [isProfilePage]="isProfilePage"></fgb-mobile-header>
<div class="account-identity-band" [ngClass]="{ 'd-none d-lg-block': !isProfilePage }">
  <div class="container">
    <fgb-account-identity-header></fgb-account-identity-header>
  </div>
  <div class="account-identity-band-curve" aria-hidden="true"></div>
</div>
<div class="container">
  <div class="row">
    <div class="col-12 col-lg-3" [ngClass]="{ 'd-none d-lg-block': !isProfilePage }">
      <fgb-account-nav [isProfilePage]="isProfilePage"></fgb-account-nav>
    </div>
    <div class="col-12 col-lg-9" [ngClass]="{ 'd-none d-lg-block': isProfilePage }">
      <ng-content></ng-content>
    </div>
  </div>
</div>
